<template>
	<!-- 我的礼物 -->
	<div class="qjylBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">我的礼物</p>
				</div>
			</div>
		</van-sticky>
		<!-- 我收到的礼物 -->
		<div class="tabbar">
			<span v-for="(item,index) in tabbarList"  :class="tabbarIndex == index ? 'active' : ''" @click="tabbarFn(index)">
				{{item}}</span>
		</div>
		<div class="qjylBoxNum" v-show="tabbarIndex == 0 && receiveGift.length != 0 ? true : false" v-for="(item,receiveIdx) in receiveGift" >
			<div class="qjylNum" @click="jumpMylwInfo(item.to_user_id)">
				<span>{{item.nickname}}</span>
				<span class="plNum"><i>{{item.count}}</i><span>个礼物</span><img src="../../assets/img/rightArr.png" alt=""></span>
			</div>
		</div>
		<div v-if="receiveGift.length == 0 && tabbarIndex == 0 ? true : false" style="text-align: center;">
			<img src="../../assets/img/data_null.png" width="80"  alt="">
		</div>
		<!-- 我送出的礼物 -->
		<div class="qjylBoxNum" v-show="tabbarIndex == 1 && sendGift.length != 0 ? true : false" v-for="(item,sendIdx) in sendGift" >
			<div class="qjylNum" @click="jumpMylwInfo(item.to_user_id)">
				<span>作品：{{item.name}}</span>
				<span class="plNum"><i>{{item.count}}</i><span>个礼物</span><img src="../../assets/img/rightArr.png" alt=""></span>
			</div>
		</div>
	</div>
</template>

<script>
	import {Toast} from 'vant'
	export default {
		data() {
			return {
				tabbarIndex: 0,
				tabbarList: ["我收到的礼物", "我送出的礼物"],
				receiveGift:[],//我收到的礼物
				sendGift:[],//我送出的礼物
			}
		},
		created() {
			this.getmygift();
		},
		methods: {
			tabbarFn(data) {
				this.tabbarIndex = data;
			},
			jumpMylwInfo(id){
				if(this.tabbarIndex == 0){
					this.$router.push({path:'/mylwinfo',query:{giftId: id}})
				}else if(this.tabbarIndex == 1){
					Toast('我送出的礼物暂无详情');
					return false;
				}
				
			},
			back() {
				this.$router.push('/userinfo')
			},
			getmygift(){
				this.$axios.post(this.$api.my_gift).then(res => {
					console.log(res);
					this.receiveGift= res.data.data.receive;
					this.sendGift = res.data.data.send;
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.qjylBox{
		background-color: #f9f9f9;
		height: 100vh;
		overflow-y: scroll;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
		
				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
		
		.tabbar {
			display: flex;
			padding: 0 15%;
			line-height: 80px;
			background-color: #fff;
			span {
				flex: 1;
				text-align: center;
				font-size: 30px;
				/*px*/
				color: #1f1f1f;
			}
		
			span.active {
				color: #ff4081;
			}
		}
		
		.qjylBoxNum {
			padding: 0 16px;
			
			padding-top: 30px;
			//我的琼浆玉露
			.qjylNum {
				background-color: #fff;
				margin-bottom: 20px;
				-webkit-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				-moz-box-shadow:  0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);/*no*/
				border-radius: 15px;
				line-height: 80px;
				padding: 20px 30px;
				display: flex;
				font-weight: 400;
				color: #000000;
				font-size: 30px;/*px*/
				span{
					flex: 1;
				}
				span:last-child{
					text-align: right;
					i{
						color: #ff4081;
						font-style: normal;
						margin-right: 10px;
					}
					img{
						width: 50px;
						vertical-align: middle;
					}
				}
			}
		}
		
	}

</style>
